// Könnyű i18n — külső lib nélkül. Nyelv: localStorage > böngésző > 'en'.
export const LANGS = [
  { code: 'en', label: 'English' },
  { code: 'hu', label: 'Magyar' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'es', label: 'Español' },
];

const T = {
  en: {
    portal: 'Partner Portal', subtitle: 'AI TourMate affiliate — sign in by email link',
    linkError: 'The sign-in link is invalid or expired. Please request a new one.',
    sent: 'If a partner account exists for this email, we have sent a sign-in link. Check your inbox (and spam folder).',
    email: 'Email address', emailPh: 'partner@example.com', requestBtn: 'Request sign-in link', sending: 'Sending...',
    noPassword: 'No password. You sign in via the link and only see your own data.',
    loading: 'Loading...', logout: 'Log out',
    account: 'Partner account', commission: 'Commission', active: 'active', inactive: 'inactive',
    conversions: 'Conversions', refunded: 'refunded',
    cumCommission: 'Cumulative commission (excl. refunds)', payable: 'Payable (pending)', paidOut: 'Paid out so far',
    monthlyCommission: 'Monthly commission (excl. refunds)', noData: 'No data yet',
    conversionsRecent: 'Conversions (latest', date: 'Date', product: 'Product', platform: 'Platform',
    gross: 'Gross', status: 'Status', ok: 'OK', noConversions: 'No conversions',
    payoutHistory: 'Payout history', noPayouts: 'No payouts yet', note: 'Note', amount: 'Amount',
    footer: 'Amounts are stored in USD; EUR/HUF are indicative conversions. Read-only view.',
    termsTitle: 'Partner Terms', termsIntro: 'Please read and accept the terms to continue.',
    termsAcceptLabel: 'I have read and accept the partner terms.',
    termsAcceptBtn: 'Accept and continue', version: 'Version',
  },
  hu: {
    portal: 'Partnerportál', subtitle: 'AI TourMate affiliate — belépés e-mail linkkel',
    linkError: 'A belépő link érvénytelen vagy lejárt. Kérj újat.',
    sent: 'Ha tartozik partnerfiók ehhez az e-mailhez, küldtünk egy belépő linket. Nézd meg a postaládád (a spam mappát is).',
    email: 'E-mail cím', emailPh: 'partner@example.com', requestBtn: 'Belépő link kérése', sending: 'Küldés...',
    noPassword: 'Jelszó nincs. A linkre kattintva lépsz be, és csak a saját adataidat látod.',
    loading: 'Betöltés...', logout: 'Kijelentkezés',
    account: 'Partnerfiók', commission: 'Jutalék', active: 'aktív', inactive: 'inaktív',
    conversions: 'Konverziók', refunded: 'refunded',
    cumCommission: 'Halmozott jutalék (refund nélkül)', payable: 'Fizetendő (függő)', paidOut: 'Eddig kifizetve',
    monthlyCommission: 'Havi jutalék (refund nélkül)', noData: 'Még nincs adat',
    conversionsRecent: 'Konverziók (legutóbbi', date: 'Dátum', product: 'Termék', platform: 'Platform',
    gross: 'Gross', status: 'Státusz', ok: 'OK', noConversions: 'Nincs konverzió',
    payoutHistory: 'Kifizetési előzmény', noPayouts: 'Még nem volt kifizetés', note: 'Megjegyzés', amount: 'Összeg',
    footer: 'Az összegek USD-ben tárolódnak; az EUR/HUF tájékoztató átváltás. Csak olvasható nézet.',
    termsTitle: 'Partneri feltételek', termsIntro: 'A folytatáshoz olvasd el és fogadd el a feltételeket.',
    termsAcceptLabel: 'Elolvastam és elfogadom a partneri feltételeket.',
    termsAcceptBtn: 'Elfogadás és belépés', version: 'Verzió',
  },
  de: {
    portal: 'Partnerportal', subtitle: 'AI TourMate Affiliate — Anmeldung per E-Mail-Link',
    linkError: 'Der Anmeldelink ist ungültig oder abgelaufen. Bitte fordere einen neuen an.',
    sent: 'Falls ein Partnerkonto für diese E-Mail existiert, haben wir einen Anmeldelink gesendet. Prüfe dein Postfach (auch Spam).',
    email: 'E-Mail-Adresse', emailPh: 'partner@example.com', requestBtn: 'Anmeldelink anfordern', sending: 'Senden...',
    noPassword: 'Kein Passwort. Du meldest dich über den Link an und siehst nur deine eigenen Daten.',
    loading: 'Laden...', logout: 'Abmelden',
    account: 'Partnerkonto', commission: 'Provision', active: 'aktiv', inactive: 'inaktiv',
    conversions: 'Conversions', refunded: 'erstattet',
    cumCommission: 'Kumulierte Provision (ohne Erstattungen)', payable: 'Auszahlbar (offen)', paidOut: 'Bisher ausgezahlt',
    monthlyCommission: 'Monatliche Provision (ohne Erstattungen)', noData: 'Noch keine Daten',
    conversionsRecent: 'Conversions (neueste', date: 'Datum', product: 'Produkt', platform: 'Plattform',
    gross: 'Brutto', status: 'Status', ok: 'OK', noConversions: 'Keine Conversions',
    payoutHistory: 'Auszahlungsverlauf', noPayouts: 'Noch keine Auszahlungen', note: 'Notiz', amount: 'Betrag',
    footer: 'Beträge werden in USD gespeichert; EUR/HUF sind Richtwerte. Nur-Lese-Ansicht.',
    termsTitle: 'Partnerbedingungen', termsIntro: 'Bitte lies und akzeptiere die Bedingungen, um fortzufahren.',
    termsAcceptLabel: 'Ich habe die Partnerbedingungen gelesen und akzeptiere sie.',
    termsAcceptBtn: 'Akzeptieren und fortfahren', version: 'Version',
  },
  fr: {
    portal: 'Portail Partenaire', subtitle: 'Affiliation AI TourMate — connexion par lien e-mail',
    linkError: 'Le lien de connexion est invalide ou expiré. Veuillez en demander un nouveau.',
    sent: 'Si un compte partenaire existe pour cet e-mail, nous avons envoyé un lien de connexion. Vérifiez votre boîte (et les spams).',
    email: 'Adresse e-mail', emailPh: 'partner@example.com', requestBtn: 'Demander un lien', sending: 'Envoi...',
    noPassword: 'Pas de mot de passe. Vous vous connectez via le lien et ne voyez que vos propres données.',
    loading: 'Chargement...', logout: 'Déconnexion',
    account: 'Compte partenaire', commission: 'Commission', active: 'actif', inactive: 'inactif',
    conversions: 'Conversions', refunded: 'remboursé',
    cumCommission: 'Commission cumulée (hors remboursements)', payable: 'À payer (en attente)', paidOut: 'Déjà payé',
    monthlyCommission: 'Commission mensuelle (hors remboursements)', noData: 'Pas encore de données',
    conversionsRecent: 'Conversions (dernières', date: 'Date', product: 'Produit', platform: 'Plateforme',
    gross: 'Brut', status: 'Statut', ok: 'OK', noConversions: 'Aucune conversion',
    payoutHistory: 'Historique des paiements', noPayouts: 'Aucun paiement', note: 'Note', amount: 'Montant',
    footer: 'Les montants sont en USD ; EUR/HUF sont indicatifs. Vue en lecture seule.',
    termsTitle: 'Conditions Partenaire', termsIntro: 'Veuillez lire et accepter les conditions pour continuer.',
    termsAcceptLabel: 'J\'ai lu et j\'accepte les conditions partenaire.',
    termsAcceptBtn: 'Accepter et continuer', version: 'Version',
  },
  it: {
    portal: 'Portale Partner', subtitle: 'Affiliazione AI TourMate — accesso tramite link e-mail',
    linkError: 'Il link di accesso non è valido o è scaduto. Richiedine uno nuovo.',
    sent: 'Se esiste un account partner per questa e-mail, abbiamo inviato un link di accesso. Controlla la posta (anche lo spam).',
    email: 'Indirizzo e-mail', emailPh: 'partner@example.com', requestBtn: 'Richiedi link di accesso', sending: 'Invio...',
    noPassword: 'Nessuna password. Accedi tramite il link e vedi solo i tuoi dati.',
    loading: 'Caricamento...', logout: 'Esci',
    account: 'Account partner', commission: 'Commissione', active: 'attivo', inactive: 'inattivo',
    conversions: 'Conversioni', refunded: 'rimborsato',
    cumCommission: 'Commissione cumulata (esclusi rimborsi)', payable: 'Da pagare (in sospeso)', paidOut: 'Pagato finora',
    monthlyCommission: 'Commissione mensile (esclusi rimborsi)', noData: 'Ancora nessun dato',
    conversionsRecent: 'Conversioni (ultime', date: 'Data', product: 'Prodotto', platform: 'Piattaforma',
    gross: 'Lordo', status: 'Stato', ok: 'OK', noConversions: 'Nessuna conversione',
    payoutHistory: 'Storico pagamenti', noPayouts: 'Nessun pagamento', note: 'Nota', amount: 'Importo',
    footer: 'Gli importi sono in USD; EUR/HUF sono indicativi. Vista in sola lettura.',
    termsTitle: 'Condizioni Partner', termsIntro: 'Leggi e accetta le condizioni per continuare.',
    termsAcceptLabel: 'Ho letto e accetto le condizioni partner.',
    termsAcceptBtn: 'Accetta e continua', version: 'Versione',
  },
  es: {
    portal: 'Portal de Socios', subtitle: 'Afiliación AI TourMate — acceso con enlace por e-mail',
    linkError: 'El enlace de acceso no es válido o ha caducado. Solicita uno nuevo.',
    sent: 'Si existe una cuenta de socio para este e-mail, te hemos enviado un enlace de acceso. Revisa tu bandeja (y el spam).',
    email: 'Correo electrónico', emailPh: 'partner@example.com', requestBtn: 'Solicitar enlace de acceso', sending: 'Enviando...',
    noPassword: 'Sin contraseña. Accedes mediante el enlace y solo ves tus propios datos.',
    loading: 'Cargando...', logout: 'Cerrar sesión',
    account: 'Cuenta de socio', commission: 'Comisión', active: 'activo', inactive: 'inactivo',
    conversions: 'Conversiones', refunded: 'reembolsado',
    cumCommission: 'Comisión acumulada (sin reembolsos)', payable: 'A pagar (pendiente)', paidOut: 'Pagado hasta ahora',
    monthlyCommission: 'Comisión mensual (sin reembolsos)', noData: 'Aún no hay datos',
    conversionsRecent: 'Conversiones (últimas', date: 'Fecha', product: 'Producto', platform: 'Plataforma',
    gross: 'Bruto', status: 'Estado', ok: 'OK', noConversions: 'Sin conversiones',
    payoutHistory: 'Historial de pagos', noPayouts: 'Aún no hay pagos', note: 'Nota', amount: 'Importe',
    footer: 'Los importes se almacenan en USD; EUR/HUF son orientativos. Vista de solo lectura.',
    termsTitle: 'Condiciones de Socio', termsIntro: 'Lee y acepta las condiciones para continuar.',
    termsAcceptLabel: 'He leído y acepto las condiciones de socio.',
    termsAcceptBtn: 'Aceptar y continuar', version: 'Versión',
  },
};

export function detectLang() {
  try {
    const q = (new URLSearchParams(window.location.search).get('lang') || '').slice(0, 2).toLowerCase();
    if (q && T[q]) return q;
  } catch (e) {}
  const saved = localStorage.getItem('lang');
  if (saved && T[saved]) return saved;
  const nav = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return T[nav] ? nav : 'en';
}

export function setLangStored(l) { try { localStorage.setItem('lang', l); } catch {} }

export function makeT(lang) {
  const dict = T[lang] || T.en;
  return (k) => (dict[k] != null ? dict[k] : (T.en[k] != null ? T.en[k] : k));
}
